(function (factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else factory(window, document);
})(function install(win, doc) {
  'use strict';
  if (win.__dmToolMeasurementV1) return win.__dmToolMeasurementV1;
  const config = doc.getElementById('dm-measurement-config');
  if (!config || !['audit', 'active'].includes(config.dataset.mode)) return null;
  const audit = config.dataset.mode === 'audit';
  const routes = Object.freeze({
    '/pages/ayuda-para-comprar': 'help_hub',
    '/pages/comparador-deportivo': 'comparator',
    '/pages/regalos-deportivos': 'gift_finder',
    '/pages/mis-favoritos': 'favorites',
    '/pages/lista-para-cotizar': 'quote_list',
    '/pages/equipamiento-deportivo-colegios-clubes-empresas': 'institutions',
    '/pages/cuida-tu-equipo': 'care_guide',
    '/pages/prepara-tu-cancha': 'court_guide',
    '/pages/preguntas-frecuentes': 'faq'
  });
  const actions = Object.freeze({
    comparator: 'compare_selection_changed',
    gift_finder: 'gift_filter_changed',
    favorites: 'favorite_saved',
    size_help: 'size_help_opened'
  });
  const seen = new WeakSet();
  const snapshots = new WeakMap();
  const panel = audit ? doc.getElementById('dm-measurement-audit') : null;
  const output = panel?.querySelector('output');
  let override = 'actual', generation = 0, allowed = 0, blocked = 0, records = [];
  const path = value => value.replace(/\/+$/, '') || '/';
  const currentTool = () => routes[path(win.location.pathname)];
  const safePath = () => currentTool() || /^\/products\/[a-z0-9-]+\/?$/.test(win.location.pathname) ? path(win.location.pathname) : '/';
  function actualConsent() {
    try {
      const privacy = win.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent().analytics === 'yes' && privacy.analyticsProcessingAllowed() === true;
    } catch { return false; }
  }
  function consent() { return !audit || override === 'actual' ? actualConsent() : override === 'granted'; }
  function draw() {
    if (!output) return;
    output.textContent = JSON.stringify({
      mode: 'AUDIT_ONLY', consent_test: override,
      actual_analytics_allowed: actualConsent(),
      privacy_api: typeof win.Shopify?.customerPrivacy?.currentVisitorConsent === 'function',
      existing_gtag: typeof win.gtag === 'function',
      eligible: allowed, blocked, sent_to_google: 0, records
    }, null, 2);
  }
  function publish(name, values, permittedAtStart, startGeneration) {
    if (!permittedAtStart || !consent() || startGeneration !== generation) {
      blocked++; draw(); return;
    }
    let data;
    if (name === 'dm_tool_use' && actions[values.tool_key] === values.action_key) {
      data = { tool_key: values.tool_key, action_key: values.action_key };
    } else if (name === 'dm_tool_link' && Object.values(routes).includes(values.tool_key)
      && ['help_hub', 'tool_page', 'product', 'navigation', 'other'].includes(values.source_context)
      && ['tool', 'product', 'quote'].includes(values.destination_kind)) {
      data = { tool_key: values.tool_key, source_context: values.source_context, destination_kind: values.destination_kind };
    } else return;
    if (!audit) {
      if (typeof win.gtag !== 'function') return;
      try {
        win.gtag('event', name, { ...data, send_to: 'G-P3T9GMGB73',
          page_location: 'https://deportemania.cl' + safePath(),
          page_referrer: '', transport_type: 'beacon' });
      } catch { return; }
      return;
    }
    allowed++;
    records.push({ event: name, ...data });
    records = records.slice(-8);
    draw();
  }
  function signature(root) {
    return Array.from(root.querySelectorAll('[data-family], [data-sport], [data-model], [data-variant], [data-third], [data-differences]'))
      .map(el => el.hasAttribute('data-family') ? el.getAttribute('aria-pressed') : el.type === 'checkbox' ? el.checked : el.value).join('|');
  }
  function baseline(target) {
    const root = target.closest('dm-product-comparator');
    if (root) snapshots.set(root, signature(root));
    if (target.matches('.dm-gift__form select[name="filter.v.price.lte"]')) snapshots.set(target, target.value);
  }
  function useAfter(tool, check, permitted, epoch) {
    win.setTimeout(() => {
      try { if (check()) publish('dm_tool_use', { tool_key: tool, action_key: actions[tool] }, permitted, epoch); }
      catch { return; }
    }, 0);
  }
  function onClick(event) {
    if (!event.isTrusted || seen.has(event)) return;
    seen.add(event);
    const target = event.target?.closest ? event.target : event.target?.parentElement;
    if (!target || panel?.contains(target)) return;
    const permitted = consent(), epoch = generation;
    const favorite = target.closest('dm-favorite-button button');
    if (favorite && favorite.getAttribute('aria-pressed') === 'false') {
      useAfter('favorites', () => favorite.isConnected && favorite.getAttribute('aria-pressed') === 'true', permitted, epoch);
    }
    const summary = target.closest('dm-size-help .dm-size-help__summary');
    if (summary) {
      const details = summary.closest('details'), wasOpen = details?.open;
      if (details && !wasOpen) useAfter('size_help', () => details.isConnected && details.open, permitted, epoch);
    }
    const family = target.closest('dm-product-comparator [data-family]');
    if (family) {
      const root = family.closest('dm-product-comparator'), before = signature(root);
      useAfter('comparator', () => { const after = signature(root); snapshots.set(root, after); return root.isConnected && before !== after; }, permitted, epoch);
    } else if (target.matches('select')) baseline(target);
    const anchor = target.closest('a[href]');
    if (!anchor || anchor.hasAttribute('download')) return;
    try {
      const url = new URL(anchor.href, win.location.href);
      if (url.origin !== win.location.origin || path(url.pathname) === path(win.location.pathname)) return;
      const destinationTool = routes[path(url.pathname)], sourceTool = currentTool();
      const tool = destinationTool || sourceTool;
      const kind = destinationTool ? destinationTool === 'quote_list' ? 'quote' : 'tool' : sourceTool && url.pathname.startsWith('/products/') ? 'product' : null;
      if (!tool || !kind) return;
      const source = sourceTool === 'help_hub' ? 'help_hub' : sourceTool ? 'tool_page' : win.location.pathname.startsWith('/products/') ? 'product' : anchor.closest('nav, header') ? 'navigation' : 'other';
      win.setTimeout(() => { if (!event.defaultPrevented) publish('dm_tool_link', { tool_key: tool, source_context: source, destination_kind: kind }, permitted, epoch); }, 0);
    } catch { return; }
  }
  function onChange(event) {
    if (!event.isTrusted || seen.has(event)) return;
    seen.add(event);
    const target = event.target;
    if (!target?.matches || panel?.contains(target)) return;
    const permitted = consent(), epoch = generation;
    const root = target.closest('dm-product-comparator');
    if (root && target.matches('[data-sport], [data-model], [data-variant], [data-third], [data-differences]')) {
      const before = snapshots.get(root);
      useAfter('comparator', () => { const after = signature(root); snapshots.set(root, after); return root.isConnected && before !== undefined && before !== after; }, permitted, epoch);
    }
    if (target.matches('.dm-gift__form select[name="filter.v.price.lte"]')) {
      const before = snapshots.get(target);
      useAfter('gift_finder', () => { const after = target.value; snapshots.set(target, after); return target.isConnected && before !== undefined && before !== after; }, permitted, epoch);
    }
  }
  function privacyChanged() { generation++; records = []; draw(); }
  doc.addEventListener('click', onClick, true);
  doc.addEventListener('change', onChange, true);
  doc.addEventListener('focusin', event => { if (event.target?.closest) baseline(event.target); }, true);
  doc.addEventListener('visitorConsentCollected', privacyChanged);
  panel?.addEventListener('change', event => {
    if (!event.target.matches('[data-dm-audit-consent]')) return;
    const value = event.target.value;
    if (!['actual', 'granted', 'denied', 'unknown'].includes(value)) return;
    override = value; privacyChanged();
  });
  panel?.addEventListener('click', event => {
    if (event.target.closest('[data-dm-audit-reset]')) { generation++; allowed = 0; blocked = 0; records = []; draw(); }
    if (event.target.closest('[data-dm-audit-reinstall]')) { install(win, doc); draw(); }
  });
  const api = Object.freeze({ version: 1, mode: audit ? 'audit' : 'active' });
  win.__dmToolMeasurementV1 = api;
  if (!win.Shopify?.customerPrivacy && typeof win.Shopify?.loadFeatures === 'function') {
    win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => draw());
  }
  draw();
  return api;
});
